import { FormGroup } from '@angular/forms';
import {
  FormRule,
  FormRuleEffect,
  FormRuleFactory,
  RuleAction,
} from 'src/app/shared/forms';
import { SubmissionConstants } from '../../models/constants/submissions-constants';
import { CustomerInfoRules } from './customerRules';
import { ManufactureDateRules } from './manufactureDateRules';
import { ZeroEnergyEligibleRules } from './zeroEnergyEligibleRules';
import { HeatPumpDocumentRules } from './heatPumpDocumentRules';

export class NeemV3CustomRules {
  constructor(
    private ruleFact: FormRuleFactory,
    private submissionsConst: SubmissionConstants,
  ) {}

  getCustomRules(subValues: FormGroup): FormRule[] {
    return [
      ...new CustomerInfoRules(
        this.ruleFact,
        this.submissionsConst,
      ).getCustomRules(subValues),
      ...new ManufactureDateRules(
        this.ruleFact,
        this.submissionsConst,
      ).getCustomRules(subValues),
      ...new HeatPumpDocumentRules(
        this.ruleFact,
        this.submissionsConst,
      ).getV3CustomRules(subValues),
      ...this.getHomeStreetRules(),
      ...this.getShouldShowDownloadInvoiceRules(subValues),
      ...new ZeroEnergyEligibleRules(
        this.ruleFact,
        this.submissionsConst,
      ).getNeemV3CustomRules(subValues),
    ];
  }
  

  private getHomeStreetRules(): FormRule[] {
    return [
      this.ruleFact.createRule(`('{homeStreet}')?.trim() === 'Tbd'`, [
        {
          action: RuleAction.MAKE_INVALID,
          affectingType: 'control',
          applyTo: 'homeStreet',
        },
        {
          action: RuleAction.SET_ERROR_MESSAGE,
          affectingType: 'control',
          applyTo: 'homeStreet',
          value: this.submissionsConst.streetAddressWarning,
        },
      ]),
    ];
  }

  private getShouldShowDownloadInvoiceRules(subValues: FormGroup): FormRule[] {
    const heatPumpInvoiceStatus = subValues.get('heatPumpInvoiceStatus')?.value;
    return [
      this.ruleFact.createRule(`${heatPumpInvoiceStatus === 'present'}`, [
        this.createBaseEffect(
          RuleAction.MAKE_VISIBLE,
          'downloadHeatPumpInvoice',
        ),
        this.createBaseEffect(
          RuleAction.MAKE_HIDDEN,
          'heatPumpInvoiceNotAvailable',
        ),
        this.createBaseEffect(
          RuleAction.MAKE_HIDDEN,
          'heatPumpInvoiceErrorMessage',
        ),
      ]),
      this.ruleFact.createRule(`${heatPumpInvoiceStatus === 'error'}`, [
        this.createBaseEffect(
          RuleAction.MAKE_HIDDEN,
          'downloadHeatPumpInvoice',
        ),
        this.createBaseEffect(
          RuleAction.MAKE_HIDDEN,
          'heatPumpInvoiceNotAvailable',
        ),
        this.createBaseEffect(
          RuleAction.MAKE_VISIBLE,
          'heatPumpInvoiceErrorMessage',
        ),
        this.createBaseEffect(
          RuleAction.SET_WARNING_MESSAGE,
          'heatPumpInvoiceErrorMessage',
          'Error retrieving invoice information. Please contact support.',
        ),
      ]),
      this.ruleFact.createRule(
        `${heatPumpInvoiceStatus !== 'present' && heatPumpInvoiceStatus !== 'error'}`,
        [
          this.createBaseEffect(
            RuleAction.MAKE_HIDDEN,
            'downloadHeatPumpInvoice',
          ),
          this.createBaseEffect(
            RuleAction.MAKE_VISIBLE,
            'heatPumpInvoiceNotAvailable',
          ),
          this.createBaseEffect(
            RuleAction.MAKE_HIDDEN,
            'heatPumpInvoiceErrorMessage',
          ),
        ],
      ),
    ];
  }

  createBaseEffect(
    action: RuleAction,
    controlToApplyTo: string,
    value?: string,
  ): FormRuleEffect {
    return {
      action: action,
      affectingType: 'control',
      applyTo: controlToApplyTo,
      value: value,
    };
  }
}
